export default __webpack_public_path__ + "static/media/48t.fee3cf97.jpg";